import { Scene } from '@babylonjs/core/scene';
import { Vector3 } from '@babylonjs/core/Maths/math';
import SceneComponent from '../components/SceneComponent';
import '@babylonjs/core/Materials/standardMaterial';
import { CameraHelper } from '../util/CameraHelper';
import { LightHelper } from '../util/LightHelper';
import { ModelLoader } from '../util/ModelLoader';
import { SceneLoader } from '@babylonjs/core/Loading/sceneLoader';
import { SceneLoaderFlags } from '@babylonjs/core/Loading/sceneLoaderFlags';
import { GLTFFileLoader, GLTFLoaderAnimationStartMode } from '@babylonjs/loaders/glTF/glTFFileLoader'
import { PipelineHelper } from '../util/PipelineHelper';
import { SpriteHelper } from '../util/SpriteHelper';
import { HoverHelper } from '../util/HoverHelper';
import { InteractionHelper } from '../util/InteractionHelper';
import { PhysicsHelper } from '../util/PhysicsHelper';

const onSceneReady = async (scene: Scene) => {

  // Physics
  PhysicsHelper.InitPhysics(scene);

  //switch coordinate system 
  scene.useRightHandedSystem = true;

  // Camera Setup
  CameraHelper.CreateMainCamera(0, 1.25, 5, Vector3.Zero(), scene);
  CameraHelper.InitCamera();

  // Light Setup
  LightHelper.CreateDefaultLighting(scene);
  LightHelper.CreateShadowGenerator();

  // Loader Setup
  SceneLoader.OnPluginActivatedObservable.addOnce((loader) => {
    if (loader.name !== 'gltf') return;
    (loader as GLTFFileLoader).animationStartMode = GLTFLoaderAnimationStartMode.NONE
  })
  SceneLoaderFlags.ShowLoadingScreen = false

  // Model loading
  let dummy = require('../models/dummy.glb')
  ModelLoader.LoadModel((dummy as string).substring(1), scene)


  // Post Processing
  PipelineHelper.InitPipeline()

  // Sprites
  // SpriteHelper.InitSprites(scene)

  // Hover
  HoverHelper.CreateHoverManager(scene);

  // Interactions
  InteractionHelper.InitInteractions(scene);

}

const onRender = (scene: Scene) => {
};

function SceneView() {
  return (
    <div className="scene">
      <SceneComponent antialias onSceneReady={onSceneReady} onRender={onRender} />
    </div>
  );
}

export default SceneView;
